import { Image } from 'antd';
import * as React from 'react';
import axios from 'axios';
import { paths } from './consts';

export const getImageAward = (awardName: string, type: string, id: number, sizeWin: number) => {
  let fileName = '';
  let size = 0;
  const sizeA = sizeWin > 700 ? 100 : 60;
  const sizeB = sizeWin > 700 ? 115 : 70;

  switch (awardName) {
    case 'Gold':
      fileName = type === 'Service' ? 'medal-gold-service' : 'medal-gold-quality';
      size = sizeA;
      break;
    case 'Silver':
      fileName = type === 'Service' ? 'medal-silver-service' : 'medal-silver-quality';
      size = sizeA;
      break;
    case 'Residential':
      fileName = 'residential';
      size = sizeB;
      break;
    case 'Ed Fielder':
      fileName = 'fielder';
      size = sizeB;
      break;
    case 'Ed Russell':
      fileName = 'russell';
      size = sizeB;
      break;
    default:
      return '';
  }

  return <Image src={`../img/${fileName}.png`} key={id}
                  width={size} preview={false}/>;
};

export const extractTextFromAssistantContent = (content: any): string => {
  if (!Array.isArray(content)) return '';

  return content
    .map((item) => {
      if (item.type === 'text') {
        return item.text?.value?.replace(/【\d+:\d+†source】/g, '')?.trim() || '';
      }
      return '';
    })
    .join('\n\n')
    .trim();
};

// export const getImagesOther = async (id: string) => {
//   const result = (await axios.get(`${process.env.REACT_APP_REST_API}${paths.IMAGESO}`)).data;
//
//   const [imgFullPath] = result.filter((path: string) => path.startsWith(`${id}/`));
//
//   return `${process.env.REACT_APP_S3_STORAGE_URL_OTHER}/${process.env.REACT_APP_BUCKET_OTHER}/${imgFullPath}`;
// };

export const getImagesOther = async (id: string): Promise<string[]> => {
  const result = (await axios.get(`${process.env.REACT_APP_REST_API}${paths.IMAGESO}`)).data;

  const matched = result.filter((path: string) => path.startsWith(`${id}/`));

  return matched.map((imgPath: string) => `${process.env.REACT_APP_S3_STORAGE_URL_OTHER}/${process.env.REACT_APP_BUCKET_OTHER}/${imgPath}`);
};

export const getImagesEvent = async (id: string, year: number) => {
  const result = (await axios.get(`${process.env.REACT_APP_REST_API}${paths.IMAGESE}/${year}`)).data;

  const [imgFullPath] = result.filter((path: string) => path.startsWith(`${id}/`));

  return `${process.env.REACT_APP_S3_STORAGE_URL_EVENT}/${process.env.REACT_APP_BUCKET_EVENT}/${imgFullPath}`;
};

export const getImagesMagazine = async (id: string) => {
  const result = (await axios.get(`${process.env.REACT_APP_REST_API}${paths.IMAGESM}`)).data;

  const [imgFullPath] = result.filter((path: string) => path.startsWith(`${id}/`));

  return `${process.env.REACT_APP_S3_STORAGE_URL_EVENT}/${process.env.REACT_APP_BUCKET_MAGAZINE}/${imgFullPath}`;
};
